import { fse, isCloudSite, isStaticSite } from "../../../electron-modules";
import { isValidURL } from "./misc-utils";

export const fetchImage = async (path: string, signal: AbortSignal = null) => {
  let blob;

  if (isStaticSite || isCloudSite || isValidURL(path)) {
    const response = await fetch(path, {signal});
    blob = await response.blob();
  } else {
    const file = await fse.readFile(path);
    blob = new Blob([file]);
  }

  const image = await createImageBitmap(blob, {
    imageOrientation: 'flipY',
    colorSpaceConversion: "none"
  });

  return image;
};

export const resizeImage = async (image: ImageBitmap, width: number, height: number) => {
  const resized = await createImageBitmap(image, {
    resizeWidth: width,
    resizeHeight: height,
    resizeQuality: "low",
    colorSpaceConversion: "none"
  });

  console.warn(`Image has been resized from (${image.width}x${image.height}) to (${width}x${height})`);

  image.close();

  return resized;
};
